import { css, jsx } from '@emotion/core';
import { Icon, Modal } from 'antd';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';
import Media from 'react-media';

import ChartDescriptions from '@/src/compliance/components/CompliAssist/ChartDescriptions';
import Button from '@/src/shared/components/Button';
import btnStyle from '@/src/shared/components/Button/style';
import Heading from '@/src/shared/components/Heading';
import { bp, space } from '@/styles';

const { m } = space;

const style = {
  titleContainer: css`
    display: flex;
    flex-direction: column;
    @media ${bp.sm} {
      flex-direction: row;
      justify-content: space-between;
    }
  `,
  title: css`
    margin-bottom: 10px;
    @media ${bp.sm} {
      margin-bottom: 0;
    }
  `,
};
const ChartDescriptionsModal = props => {
  const { closeModal, visible } = props;

  return (
    <Media query={bp.sm}>
      {isSM => (
        <Modal
          footer={null}
          title={
            <span css={style.titleContainer}>
              <Heading type={3} weight="bolder" theme="gray" css={style.title}>
                Chart Descriptions
              </Heading>
              <Link href="/compliance/compliassist/charts">
                <a target="_blank">
                  <Button.Group theme="gray" css={[btnStyle.group, m.r24]}>
                    <Button>
                      <Icon type="printer" theme="filled" /> Print Version
                    </Button>
                  </Button.Group>
                </a>
              </Link>
            </span>
          }
          onCancel={closeModal}
          visible={visible}
          width={isSM ? '71%' : '90%'}
          maskStyle={{
            backgroundColor: 'rgba(0,38,73,0.65)',
          }}
        >
          <ChartDescriptions />
        </Modal>
      )}
    </Media>
  );
};

ChartDescriptionsModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
};

export default ChartDescriptionsModal;
